module.exports = __webpack_public_path__ + "img/bb_g1_t_antenna-03.e87107f9.svg";